import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconServer1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconServer1"><Path d="M19.25 5.31944C19.25 6.73851 16.0041 7.88889 12 7.88889C7.99594 7.88889 4.75 6.73851 4.75 5.31944M19.25 5.31944C19.25 3.90038 16.0041 2.75 12 2.75C7.99594 2.75 4.75 3.90038 4.75 5.31944M19.25 5.31944V18.6806C19.25 20.0996 16.0041 21.25 12 21.25C7.99594 21.25 4.75 20.0996 4.75 18.6806V5.31944M19.25 12C19.25 13.3807 16.0041 14.5 12 14.5C7.99594 14.5 4.75 13.3807 4.75 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconServer1;
